$shm_hitalama_map_camera_url $mol_plugin
	state_key \
	zoom? 1
	shift? $mol_vector_2d<number> /
		0
		0
	zoom_default 1
	shift_default $mol_vector_2d<number> /
		100
		100
